import React from 'react'
import styled from 'styled-components'

import { media } from '../utils/style-utils'

const Title = styled.h2`
  font-weight: 100;
  letter-spacing: 0.05em;
  line-height: 1.12;
  text-transform: uppercase;
  font-size: 1.5rem;

  ${media.tablet`
    font-size: 2.66rem;
    span {
        display: block;
    }
  `};
`

const FancyTitle = props => {
  const { className, children } = props
  return (
    <Title className={className}>
      {children
        .split(' ')
        .map((word, index) => <span key={index}>{word} </span>)}
    </Title>
  )
}

export default FancyTitle



// WEBPACK FOOTER //
// ./src/components/FancyTitle.js